import type { Progress } from "../../domains/DrillProgress";
import type { paths } from "../../lib/api/v1";

// contents API
type ContentsPath =
  "/api/v1/sections/{section_id}/drill_learning_materials/{steak_material_code}/drill_sections/{drill_section_public_id}/contents";
type ContentsResponse =
  paths[ContentsPath]["get"]["responses"]["200"]["content"]["application/json"];
type ContentsResponseContent = ContentsResponse["contents"][number];

export type DrillContentItem = ContentsResponseContent["items"][number];

export type DrillContent = Omit<ContentsResponseContent, "progress"> & {
  progress: Progress;
};

export type DrillSectionContentsResponse = {
  contents: DrillContent[];
};

// students_with_answers API
type StudentsPath =
  "/api/v1/sections/{section_id}/drill_learning_materials/{steak_material_code}/students_with_answers";
type StudentsResponse =
  paths[StudentsPath]["get"]["responses"]["200"]["content"]["application/json"];

export type StudentWithAnswers =
  StudentsResponse["studentsWithAnswers"][number];

export type StudentAnswerItem = StudentWithAnswers["items"][number];

export type StudentsWithAnswersResponse = StudentsResponse;

// DISP-13: 回答を持たないアイテム種別。
// TODO: OpenAPI 上 itemType が `string | null` で enum 未定義のため、文字列決め打ちで持つ。
// 理想はバックエンドに enum 定義してもらい、ここから生成型に置換すること（DISP-09 の SCORE_INPUT_ITEM_TYPE と同じ温度感）。
export const NON_ANSWERABLE_ITEM_TYPES = [
  "horizontal_writing",
  "image",
  "sound",
  "pdf",
] as const;

export const isNonAnswerableItem = (
  item: DrillContentItem | undefined,
): boolean => {
  if (!item?.itemType) {
    return false;
  }
  return NON_ANSWERABLE_ITEM_TYPES.includes(
    item.itemType as (typeof NON_ANSWERABLE_ITEM_TYPES)[number],
  );
};

// DISP-13: コンテンツ配下のアイテムが全て回答を持たない種別なら true。
// 回答可能アイテムが 1 件でも含まれれば false (= 集計に意味がある = 進捗表示する)。
// アイテム 0 件 (理論上存在しないが防御的に) は false 扱い。
export const isFullyNonAnswerableContent = (content: DrillContent): boolean =>
  content.items.length > 0 && content.items.every(isNonAnswerableItem);
